import axios from 'axios';
import qs from "qs";

const checkoutProcessApi = axios.create({
    baseURL: URL_CHECKOUT_API
});

checkoutProcessApi.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
    return request;
}, error => Promise.reject(error));

/**const coursesApi = axios.create({
    baseURL: URL_ORDERS_API
});

coursesApi.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
    //console.log('token'+request.headers.Authorization);
    return request;
}, error => Promise.reject(error));
axios.interceptors.response.use(response => response, error =>
    Promise.reject(error),
);**/

//const getOrders = ({id_course,searchWord,ordersIamIn}) => coursesApi.post(`course/getTransactions`, qs.stringify({search: searchWord, ordersIamIn:ordersIamIn,id_course}));
const getSeats = ({id_transaction,id_course_seat_people}) => checkoutProcessApi.post(`course/getTransactionSeats`, qs.stringify({id_course_seat_people, id_transaction}));
const requestRefund = (data) => checkoutProcessApi.post(`course/requestRefundSeatPeople`, qs.stringify(data));
const cancelSeat = (data) => checkoutProcessApi.post(`course/cancelSeat`, qs.stringify(data));

export default {
    //getOrders,
    requestRefund,
    cancelSeat,
    getSeats
};
